import { keepPreviousData, useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = {};
const preferencesFromJSON = (preferences) => {
  const { attributes, sort, per_page, slicing, custom_preferences, order } = preferences;
  const hasSlicingPreference = Object.prototype.hasOwnProperty.call(preferences, "slicing");
  const result = {
    attributes,
    sort: sort ? { attributeId: sort.field, direction: sort.order } : void 0,
    perPage: per_page,
    customPreferences: custom_preferences,
    order
  };
  if (hasSlicingPreference) {
    result.slicing = slicing ? {
      sliceColumn: slicing.slice_column,
      sortBy: slicing.sort_by,
      order: slicing.order
    } : null;
  }
  return result;
};
const preferencesUrl = (entityId, layoutVariant) => {
  const params = layoutVariant ? `?layout_variant=${encodeURIComponent(layoutVariant)}` : "";
  return qualifyUrl(`/entitylists/preferences/${entityId}${params}`);
};
const fetchUserLayoutPreferences = (entityId, layoutVariant) => fetch("GET", preferencesUrl(entityId, layoutVariant)).then((res) => preferencesFromJSON(res != null ? res : {}));
const useUserLayoutPreferences = (entityId, layoutVariant) => {
  const {
    data,
    isLoading: isInitialLoading,
    refetch
  } = useQuery({
    queryKey: ["table-layout", entityId, layoutVariant],
    queryFn: () => defaultOnError(
      fetchUserLayoutPreferences(entityId, layoutVariant),
      `Loading layout preferences for "${entityId}" overview failed with`
    ),
    placeholderData: keepPreviousData,
    // 1 hour
    staleTime: 60 * (60 * 1e3)
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    isInitialLoading,
    refetch
  };
};
export default useUserLayoutPreferences;
